import { Component, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapSizeComponent } from '../../../../parts/development/bootstrap-size.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ThemeService } from '../../../../core/services/theme.service';
import { ThemeSwitcher } from "../../../../parts/theme-switcher/theme-switcher";
import { AuthService } from '@auth0/auth0-angular';
import { UserSessionService } from '../../../../core/services/user-session.service';
import { AuthorizationStateService } from '../../../../core/services/authorization/authorization-state.service';
import { UserService } from '../../../../core/services/user.service';
import { TopMenuUserComponent } from '../top-menu-user/top-menu-user.component';
import { RouterLink } from '@angular/router';
import { TooltipDirective, TooltipPlacement } from '../../../../core/directives/tooltip.directive';

@Component({
  selector: 'ms-header',
  imports: [BootstrapSizeComponent, FontAwesomeModule, CommonModule, ThemeSwitcher, TopMenuUserComponent, RouterLink, TooltipDirective],
  templateUrl: './header.component.html',
  styleUrl: 'header.component.scss'
})
export class HeaderComponent {
  public isSidebarCollapsed = model<boolean>();
  public TooltipPlacement = TooltipPlacement;
  public isScrolled = false;

  public currentTheme$;
  public isDarkThemeActive$;

  constructor(
    private themeService: ThemeService,
    public authService: AuthService,
    public userSessionService: UserSessionService,
    private authorizationStateService: AuthorizationStateService,
    private userService: UserService
  ) {
    this.currentTheme$ = this.themeService.currentTheme$;
    this.isDarkThemeActive$ = this.themeService.isDarkThemeActive$;
  }

  public async ngOnInit(): Promise<void> {
    await this.userService.updateLastLoginDate(this.userSessionService.activeUser()!.userId);
  }

  public setTheme(theme: string): void {
    this.themeService.setTheme(theme);
  }

  public toggleSidebar(): void {
    this.isSidebarCollapsed.set(!this.isSidebarCollapsed());
  }

  public logOut() {
    try {
      this.authorizationStateService.clearContext();
      this.userSessionService.clearLocalStorage();

      this.authService.logout({
        logoutParams: {
          returnTo: window.location.origin + '/sign-in',
          federated: true
        }
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
  }

}
